import { useEffect } from "react";

import Field from "../field";
import { getPositiveInteger } from "../utils";

const getSubgroupNumber = (i, subgroupsCount) => (i % subgroupsCount) + 1;

export default function EditSubgroups({
  students,
  subgroupsCount,
  setSubgroupsCount,
  subgroups,
  setSubgroups,
}) {
  useEffect(() => {
    if (students) {
      setSubgroups(
        students.map((elem, i) => ({
          studentId: elem.id,
          fullName: elem.fullName,
          subgroupNumber: getSubgroupNumber(i, subgroupsCount),
        })),
      );
    }
  }, [students]);

  const onChangeSubgroupsCount = (e) => {
    const newSubgroupsCount = getPositiveInteger(e.target.value);

    setSubgroupsCount(newSubgroupsCount);

    setSubgroups((prev) =>
      prev.map((elem, i) => ({
        studentId: elem.studentId,
        fullName: elem.fullName,
        subgroupNumber: getSubgroupNumber(i, newSubgroupsCount),
      })),
    );
  };

  if (!subgroups.length) {
    return;
  }

  return (
    <div className="subpanel">
      <Field label="Количество подгрупп" required>
        <input
          type="number"
          min="1"
          value={subgroupsCount}
          onChange={onChangeSubgroupsCount}
        />
      </Field>
      <div className="assign-list">
        <div className="field-label">Распределение студентов по подгруппам</div>
        {subgroups.map((s) => (
          <div className="assign-row" key={s.studentId}>
            <span>{s.fullName}</span>
            <select
              value={s.subgroupNumber}
              onChange={(e) =>
                setSubgroups((prev) =>
                  prev.map((p) =>
                    p.studentId === s.studentId
                      ? {
                          ...p,
                          subgroupNumber: Number(e.target.value),
                        }
                      : p,
                  ),
                )
              }
            >
              {Array.from({ length: subgroupsCount }, (_, i) => i + 1).map(
                (n) => (
                  <option key={n} value={n}>
                    Подгруппа {n}
                  </option>
                ),
              )}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
